(function () {
  const AUTOPLAY_DELAY_MS = 2000;

  function applyVideoStartOffset(media) {
    const startOffset = parseInt(media.dataset.startTime, 10);
    if (!startOffset || startOffset <= 0) return;

    const video = media.querySelector('video');
    if (!video) return;

    const seek = () => {
      try {
        video.currentTime = startOffset;
      } catch (e) {
        /* ignore seek errors */
      }
    };

    if (video.readyState >= 1) {
      seek();
    } else {
      video.addEventListener('loadedmetadata', seek, { once: true });
    }
  }

  function scheduleAutoplay(media) {
    const startPlayback = () => {
      if (media.hasAttribute('loaded')) return;
      if (typeof media.loadContent === 'function') {
        media.loadContent(false);
        applyVideoStartOffset(media);
      }
    };

    const run = () => window.setTimeout(startPlayback, AUTOPLAY_DELAY_MS);

    if (document.readyState === 'complete') {
      run();
    } else {
      window.addEventListener('load', run, { once: true });
    }
  }

  function init() {
    document.querySelectorAll('.video-section__media[data-autoplay-delay]').forEach(scheduleAutoplay);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
